module.exports = __webpack_public_path__ + "ccae45747456f4faee56e0322edbf4b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/svg-symbol-viewer-logo.svg
// module id = 223
// module chunks = 0